// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1YjVd","footer":"ReportModalFilter_footer__1HqjX"};